import { Pipe, PipeTransform } from '@angular/core';
import { GrowthSignalAgentDashboardListDto } from 'src/app/shared/dto';

@Pipe({
  name: 'growthSignalsAgentLabel',
  standalone: true,
})
export class GrowthSignalsAgentLabelPipe implements PipeTransform {
  transform(agent: GrowthSignalAgentDashboardListDto | null | undefined): string {
    if (!agent) {
      return 'All Agents';
    }

    const signalName = agent.signal_type ?? 'Signal';
    return `${signalName} - ${agent.name}`;
  }
}
